import fileViewerService from './fileViewerService';
import AppFileViewer from './AppFileViewer.vue';

export {
    AppFileViewer
};

export default fileViewerService;
